import { View, Text, StyleSheet } from "react-native";
import { useAppConfig } from "../../../AppConfigProvider";

function UserInitial({ initial, type }) {
  const { primaryColor } = useAppConfig();

  const isMenu = type === "menu";

  const containerStyle = [
    styles.container,
    isMenu
      ? {
          backgroundColor: `${primaryColor}3A`, // 1A is 10% opacity in hex
          height: 36,
          width: 36,
          borderRadius: 24,
        }
      : {
          backgroundColor: primaryColor,
        },
  ];

  const textStyle = [
    styles.text,
    isMenu && {
      color: primaryColor,
      fontSize: 20,
    },
  ];

  return (
    <View style={containerStyle}>
      <Text style={textStyle}>{initial}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 24,
    width: 24,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    color: "#fff",
    fontSize: 14,
    fontWeight: "bold",
  },
});

export default UserInitial;
